import React, { useContext, useState } from 'react';

import { Add } from '@mui/icons-material';
import { callAPIWhileSettingState, generateClassName, generateTextField, handleObjectFieldChange } from '../../b2b-common/helpers';
import B2BFormContainer from '../../b2b-common/B2BFormContainer';

import './AddB2BIndicatorForm.css'
import { LoginContext } from '../../../App';
import { addB2BIndicator } from '../../../services/b2b-frameworks-apiService';

const AddB2BIndicatorForm = ({ frameworkSuite, framework, levelN, className = null, onAddedB2BIndicator }) => {

    const { loginData } = useContext(LoginContext);
    const [error, setError] = useState(null);

    const defaultNewB2BIndicatorFields = {
        indicatorUUID: '',
    };

    const [newB2BIndicatorFields, setNewB2BIndicatorFields] = useState(defaultNewB2BIndicatorFields);

    const addToLevelNB2BIndicator = async (indicatorUUID) => {
        try {
            const paramsArray = [
                frameworkSuite,
                framework.frameworkId,
                levelN.levelN_ItemId,
                indicatorUUID,
                loginData.accessToken,
            ];
            await callAPIWhileSettingState(addB2BIndicator, paramsArray, null, null);
        } catch (error) {
            setError(error.message);
        }
    }

    const handleAddB2BIndicator = async () => {
        console.log('handleAddB2BIndicator: ', newB2BIndicatorFields);
        await addToLevelNB2BIndicator(newB2BIndicatorFields.indicatorUUID);
        setNewB2BIndicatorFields(defaultNewB2BIndicatorFields);
        if (onAddedB2BIndicator) {
            onAddedB2BIndicator();
        }
    }

    const buttonsConfig = [
        {
            label: 'Add',
            disabledText: 'Add',
            onClick: handleAddB2BIndicator,
            color: 'secondary',
            variant: 'contained',
            key: '1',
            icon: <Add />,
        },
    ];

    return (
        <B2BFormContainer title={"Add indicator by UUID form"} className={generateClassName("new-b2bindicator-form", "", className)} orientation="horizontal" showDivider={false} buttonsConfig={buttonsConfig}>
            {generateTextField("Indicator UUID", newB2BIndicatorFields.indicatorUUID, generateClassName("new-b2bindicator-form", "-indicator-uuid", className), false, (e) => handleObjectFieldChange('indicatorUUID', e.target.value, setNewB2BIndicatorFields), { required: true })}
        </B2BFormContainer>
    );
};

export default AddB2BIndicatorForm;